import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { countryCodes } from '../../utils/countryCodes';
import './CountryCodeSelect.css';

const CountryCodeSelect = ({ value, onChange, placeholder = 'Select Code', className = '' }) => {
    const { t } = useTranslation();
    const [showDropdown, setShowDropdown] = useState(false);
    const [search, setSearch] = useState('');
    const dropdownRef = useRef(null);

    const filteredCountries = countryCodes.filter(country =>
        country.name.toLowerCase().includes(search.toLowerCase()) ||
        country.code.includes(search) ||
        country.country.toLowerCase().includes(search.toLowerCase())
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedCountry = countryCodes.find(c => c.code === value);

    return (
        <div className={`country-code-select-wrapper ${className}`} ref={dropdownRef}>
            <button
                type="button"
                className={`country-code-toggle ${!value ? 'empty' : ''}`}
                onClick={() => setShowDropdown(!showDropdown)}
            >
                {selectedCountry ? (
                    <>
                        <span className="current-flag">{selectedCountry.flag}</span>
                        <span className="current-code">{selectedCountry.code}</span>
                    </>
                ) : (
                    <>
                        <i className="bi bi-globe-americas placeholder-icon"></i>
                        <span className="placeholder-text">{placeholder}</span>
                    </>
                )}
                <i className={`bi bi-chevron-${showDropdown ? 'up' : 'down'} toggle-icon`}></i>
            </button>

            {showDropdown && (
                <div className="country-code-dropdown">
                    <div className="dropdown-search">
                        <i className="bi bi-search search-icon"></i>
                        <input
                            id="countrySearchInput"
                            name="countrySearchInput"
                            type="text"
                            placeholder={t('search_country', 'Search...')}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            autoFocus
                            onClick={(e) => e.stopPropagation()}
                        />
                        {search && (
                            <i
                                className="bi bi-x clear-icon"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSearch('');
                                }}
                            ></i>
                        )}
                    </div>

                    <div className="dropdown-list">
                        <div
                            className={`dropdown-item ${value === '' ? 'selected' : ''}`}
                            onClick={() => {
                                onChange('');
                                setShowDropdown(false);
                                setSearch('');
                            }}
                        >
                            <span className="item-flag">🌍</span>
                            <span className="item-name">{t('all_countries', 'All Countries')}</span>
                        </div>
                        {filteredCountries.map((country) => (
                            <div
                                key={country.code}
                                className={`dropdown-item ${value === country.code ? 'selected' : ''}`}
                                onClick={() => {
                                    onChange(country.code);
                                    setShowDropdown(false);
                                    setSearch('');
                                }}
                            >
                                <span className="item-flag">{country.flag}</span>
                                <span className="item-name">{country.name}</span>
                                <span className="item-code">{country.code}</span>
                            </div>
                        ))}
                        {filteredCountries.length === 0 && (
                            <div className="dropdown-no-results">
                                {t('no_countries_found', 'No countries found')}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CountryCodeSelect;
